import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import promiseMiddleware from 'redux-promise-middleware'

import reducer from './reducers'
import { StoreState } from './reducers'

const middlewares = [
  thunk,
  createLogger(),
  promiseMiddleware()
]

export default createStore<StoreState>(reducer, applyMiddleware(...middlewares))



// WEBPACK FOOTER //
// ./src/store.tsx